import React from "react";
import { t } from "ttag";

import { ArticleCardsBlock as Value } from "@reactivated";

import { Carousel } from "../GoodcookCarousel";
import { ArticleCard } from "./ArticleCard";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

export const ArticleCardsBlock = ({ value, id }: Props) => {
    if (!value.articles || value.articles.length === 0) {
        return null;
    }

    return (
        <Carousel
            label={value.block_label || t`Article Cards`}
            scrollContainerProps={{ className: styles.scrollContainer }}
        >
            {value.articles.map((article, index) => (
                <ArticleCard
                    article={article}
                    key={`${id}-${article.id}-${index}`}
                />
            ))}
        </Carousel>
    );
};
